module.exports = __webpack_public_path__ + "static/media/smartphone.c37bab61.svg";